import { Container, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { isAdmin, isManager } from '../../services/auth';

import ImporterTable from "./importerTable";
import PageHeaderButton from '../../components/pageHeaderButton';
import { api } from '../../services/api';
import Autocomplete from '@mui/material/Autocomplete';
import FormCard from "../../components/forms/formCard";
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';

const Importer = props => {
    const [importerList, setImporterList] = useState([]);
    const [field, setField] = useState("");
    const [valuesList, setValuesList] = useState([]);
    const [srcImporterList, setSrcImporterList] = useState([]);

    useEffect(() => {
        let mounted = true;
        api.getImporters()
            .then(resp => {
                if (mounted && resp) {
                    setImporterList(resp);
                    setSrcImporterList(resp);
                }
            })
        return () => mounted = false;
    }, [])

    const mapFields = {
        "Nome": "razaoSocial",
        "Código ERP": "codigoERP",
        "Tax ID": "taxId",
        "Status": "status"
    }

    const statusValue = [
        "Ativo",
        "Inativo"
    ]

    const handleFieldSelect = (value) => {
        if (value) {
            let valuesFiltered = [];
            if (mapFields[value] === "status") {
                setValuesList(statusValue);
                setField(mapFields[value]);

            } else { 
                valuesFiltered = srcImporterList?.map(user => user[mapFields[value]]);

                setValuesList(valuesFiltered?.filter((item, index) => valuesFiltered.indexOf(item) === index));
                setField(mapFields[value]);
            }
        }
    }

    const handleValueSelect = (value) => {
        if (value && value?.length > 0) {
            let importerFiltered = [];
            if (field === "status") {
                if (value == "Ativo") {
                    importerFiltered = srcImporterList.filter(u => u.inativoDesde ===   null);
                    setImporterList(importerFiltered);
                }
                if (value == "Inativo") {
                    importerFiltered = srcImporterList.filter(u => u.inativoDesde !== null);
                    setImporterList(importerFiltered);
                }

            } else {
            importerFiltered = srcImporterList.filter(u => value.includes(u[field]));

            setImporterList(importerFiltered);
            }
        } else {
            setImporterList(srcImporterList);
        }
    };

    return (
        <Container maxWidth="xg" sx={{ mt: 4, mb: 4 }}>
            <Grid item xs={12}>
            <PageHeaderButton canCreate={isAdmin() || isManager()} title="Clientes" path="/importers" ></PageHeaderButton>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ my: { xs: 3, md: 1 }, p: { xs: 2, md: 3 }, borderRadius: '10px' }}>
                        <Grid item xs={12} sm={12}>
                            <FormCard title="Filtros">
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            size="small"
                                            disablePortal
                                            id="field"
                                            getOptionLabel={(option) => option}
                                            options={Object.keys(mapFields)}
                                            onChange={(event, value) => handleFieldSelect(value)}
                                            sx={{ width: "100%" }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: "12px" } }}
                                                InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "12px" } }}
                                                label="Campo a ser filtrado" />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            disablePortal
                                            id="value"
                                            getOptionLabel={(option) => option}
                                            options={valuesList}
                                            onChange={(event, value) => handleValueSelect(value)}
                                            sx={{ width: "100%" }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                label="Conteúdo"
                                                InputProps={{ ...params.InputProps, style: { fontSize: "12px" } }}
                                                InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "12px" } }}
                                            />}
                                        />
                                    </Grid>
                                </Grid>
                            </FormCard>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <ImporterTable rows={importerList}/>
            </Grid>
        </Container>
    );

};

export default Importer;